<script lang="ts">
    import type { ProductTitle } from './ProductTitle';

    interface Props {
        title: ProductTitle;
    }

    let { title }: Props = $props();
</script>

<p class={['reptile-product-title', 'oc-copy-100', 'oc-text-color-default']}>
    <span class="reptile-product-title__brand">{title.brand}</span>
    <span class="reptile-product-title__title">{title.display}</span>
</p>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-product-title {
        display: flex;
        flex-direction: column;
        row-gap: tokens.$oc-semantic-spacing-25;
        margin: 0;

        &__brand {
            display: block;
            font: tokens.$oc-semantic-font-copy-75;
            text-align: left;
            text-transform: uppercase;

            @include mixins.text-clamp(2);
        }

        &__title {
            @include mixins.text-clamp(4);
        }
    }
</style>
